import { createVNode as t, mergeProps as s } from "vue";
import i from "../node_modules/@pf-ui/pf-icon-svg/es/asn/CloseFilled.js";
import m from "../components/PfIcon.js";
const e = (o, r) => {
  const l = {
    ...o,
    ...r.attrs
  };
  return t(m, s(l, {
    icon: i
  }), null);
};
e.displayName = "CloseFilled";
e.inheritAttrs = !1;
export {
  e as default
};
